<template>
<div class="NavMenu_ui">
    <div class="NavMenu_box" :class="{'open':isOpen=='T'}">
        <div class="menu_list">
            <div class="menu_item" v-for="(item,i) in datas.items" :key="i" @click="goPage(item)">
                <div class="icon">
                    <img :src="item.logo">
                </div>
                <div class="desc">
                    {{item.desc}}
                </div>
            </div>
           
        </div>
        <div class="NavMenu_btn" @click="openClose" v-if="datas.items.length>1">
            <div v-if="isOpen=='T'">
              <i class="iconfont iconshang"></i>
            </div>
            <div v-else>
                导航<br>
                菜单
            </div>

        </div>
    </div>
</div>
</template>

<script>
// 菜单项
import {
    jAlert3,
    jAlert5
} from "@/base/jAlert/jAlert";
import {
    getStorage
} from '@/utils/wxuser';

export default {
    props: ["datas"],
    data() {
        return {
            isOpen: 'F'

        };
    },

    computed: {

    },
    methods: {
        goPage(item) {
            if (item.url) {
                window.location.href = item.url
            }
        },
        openClose() {
            if (this.isOpen == 'T') {
                this.isOpen = 'F'
            } else {
                this.isOpen = 'T'
            }
        }
    },
    mounted() {
        if(this.datas.items&&this.datas.items.length==1){
             this.isOpen = 'T'
        }
    }
};
</script>

<style lang="less" scoped>
.NavMenu_ui {
    .NavMenu_box {
        position: fixed;
        right: 6%;
        bottom: 12%;
        z-index: 10;
        background: #FFFFFF;
        border-radius: 25px;

        &.open {
            .menu_list {
                padding: 0.32rem 0 0.213333rem;
                height: auto;
            }

        }

        .NavMenu_btn {
            display: flex;
            border-radius: 50%;
            line-height: 1.4;
            align-items: center;
            justify-content: center;
            height: 1.333333rem;
            width: 1.333333rem;
            background: #FFFFFF;
            box-shadow: 0px -5px 10px 0px rgba(0, 0, 0, 0.1);
            i{
              font-size: 20px;
              color: #999;
            }
        }

        .menu_list {
            height: 0;
            box-sizing: border-box;
            overflow: hidden;
            transition: all 0.2s;
        }

        .menu_item {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            padding: 0.213333rem 0;
            width: 1.333333rem;

            .icon {
                img {
                    width: 0.453333rem;
                    height: 0.453333rem;
                }
            }

            .desc {
                margin-top: 0.213333rem;
                font-size: 10px;
                color: #333333;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/NavMenu.vue